// Dto
import SeStoreDTO from "../dto/SeStoreDTO"

// Types
import { GeoData, GeoDomaine, GeoParentStation, GeoStation, GeoRegion, GeoParentStationsMap, GeoRegionsMap, GeoDomainesMap, GeoStationsMap} from "@/types/geodata"

const buildSearchEventString = (seStore: SeStoreDTO, geoData: GeoData): string => {
    const stationStringArr: string[] = [
        buildStationString(seStore.station, geoData.stationsMap),
        buildParentStationString(seStore.parentStation, geoData.parentStationsMap),
        buildDomainString(seStore.domaineSki, geoData.domainsMap),
        buildRegionString(seStore.region, geoData.regionsMap)
    ].filter((item: string ) => item.length)

    return stationStringArr.join(",")
}

const buildStationString = (stations: number[] | undefined, geoStationsMap: GeoStationsMap): string => {
    if(!stations || !Array.isArray(stations)) return ""
    // For some reason stations is an array in the se, even though there could only be one selected station, so get the first one
    const selectedStationId: number = stations[0]
    const selectedStation: GeoStation = geoStationsMap[selectedStationId]

    return selectedStation?.label || ""
}

const buildParentStationString = (parentStations: number[] | undefined, geoParentStationsMap: GeoParentStationsMap): string => {
    if(!parentStations || !Array.isArray(parentStations)) return ""
    // For some reason parentStations is an array in the se, even though there could only be one selected station, so get the first one
    const selectedParentStationId: number = parentStations[0]
    const selectedParentStation: GeoParentStation = geoParentStationsMap[selectedParentStationId]

    return selectedParentStation?.label || ""
}

const buildDomainString = (domainId: string | undefined, geoDomainsMap: GeoDomainesMap): string => {
    if(!domainId) return ""
    const selectedDomain: GeoDomaine = geoDomainsMap[domainId]
    return selectedDomain?.label || ""
}

const buildRegionString = (regionId: string | undefined, geoRegionsMap: GeoRegionsMap): string => {
    if(!regionId) return ""
    const selectedRegion: GeoRegion = geoRegionsMap[regionId]
    return selectedRegion?.label || ""
}

export default buildSearchEventString